export default __webpack_public_path__ + "static/media/Stretch-Yarn-Digital.576ecdf7.pdf";